/// \file accountRoutes.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import { Route } from "react-router-dom";
import accountSubscriptions from "./accountSubscriptions";
import userAgreements from "./userAgreements";
const routes = (
  <Route
    path="account"
    handle={{
      text: 'ACCOUNT'
    }}
    >
    {accountSubscriptions}
    {userAgreements}
  </Route>
);

export default routes;